import { Header } from "./components/Header";
import { Slider } from "./components/slider";
import 'swiper/swiper.scss'


const main = {
  init: function() {
    window.addEventListener("readystatechange", this.load(document.readyState));
  },
  load: (readyState) => {
    switch (readyState) {
      case "loading":
        Slider.init();
     
      case "load":

      case "interactive":
      case "loaded":
        Header.init();
  
      case "complete":
      default:
        break;
    }
  },
};

export default main;
